import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
	name: 'delimiter'
})

export class DelimiterPipe implements PipeTransform {

	currentLanguage: string = 'de';

	constructor(
		private translateService: TranslateService
	) {
		this.currentLanguage = this.translateService.currentLang;
		this.translateService.onLangChange.subscribe(response => {
			this.currentLanguage = response.lang;
		});
	}

	transform(value: string, ...args: unknown[]) {
		if (value) {
			// strip everything except numbers, dots, commas
			value = value?.toString().replace(/[^\d,.]/g, '');
			if (this.currentLanguage === "en") {
				value = value.replace(/,/g, ''); // strip out commas
				return parseFloat(value); // convert to number
			} else if (this.currentLanguage === "de") {
				// either in German locale or not match #,###.###### and now matches #.###,########
				value = value.replace('.', ','); // strip out dots
				value = value.replace(/\./g, ''); // strip out dots
				value = value.replace(/,/g, '.'); // replace comma with dot
				return parseFloat(value);
			} else {
				value = value.replace(/,/g, ''); // strip out commas
				return parseFloat(value); // convert to number
			}
		}
		return 0;
	}
}
